var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page-tabs-container d-flex align-center justify-center"},[_c('client-only',[_c('hotel-search-form',{attrs:{"is-iframe":"","city-id":_vm.cityId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }